var map = {
	"./Freemium/freemium.routes.js": 1308,
	"./MentorShip/mentorship.routes.js": 1295,
	"./PrivateClasses/private-classes.routes.js": 1289,
	"./dashboard/dashboard.routes.js": 1309,
	"./disciplines/disciplines.routes.js": 1293,
	"./essay/essay.routes.js": 1297,
	"./extractsignature/extractsignature.routes.js": 1302,
	"./forgetpassword/forgetpassword.routes.js": 1303,
	"./lessonquestions/lessons-questions.routes.js": 1298,
	"./lessons/lessons.routes.js": 1299,
	"./liveClasses/liveClasses.routes.js": 1296,
	"./login/login.routes.js": 1304,
	"./newpassword/newpassword.routes.js": 1305,
	"./shifts/shifts.routes.js": 1306,
	"./studentForm/student-form.routes.js": 1291,
	"./studyplans/study-plans.routes.js": 1292,
	"./subscription/subscription.routes.js": 1287,
	"./teachingMaterials/teachingMaterials.routes.js": 1307,
	"./test/test.routes.js": 1290,
	"./userAccount/userAccount.routes.js": 1294,
	"./userPasswordChange/userPasswordChange.routes.js": 1300
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 992;